type Props = {
  label: string;
  score: number;
  max: number;
  color: 'design' | 'deliver' | 'adopt' | 'grow' | 'sunrise' | 'sunset';
};

const HEX: Record<Props['color'], string> = {
  design: '#3D55D6',
  deliver: '#5B7CFF',
  adopt: '#9A988F',
  grow: '#3FA96B',
  sunrise: '#C7851A',
  sunset: '#D64545',
};

export function PillarBar({ label, score, max, color }: Props) {
  const pct = Math.max(0, Math.min(100, (score / max) * 100));
  return (
    <div className="flex items-center gap-3">
      <div className="text-[11px] uppercase tracking-widest text-neutral-500 w-32 shrink-0">{label}</div>
      <div className="flex-1 h-2 rounded-full bg-surface-3 overflow-hidden">
        <div
          className="h-full rounded-full transition-[width]"
          style={{ width: `${pct}%`, background: HEX[color] }}
        />
      </div>
      <div className="text-xs text-neutral-400 tabular-nums w-12 text-right">
        {score}/{max}
      </div>
    </div>
  );
}
